import { connect } from 'react-redux';

import { BucketState } from 'src/types/state';

import FileDetailsCard from '../components/file-details-card';

const mapStateToProps = (state: BucketState) => {
  const { hash } = state.repository.source.section;
  const { file, meta, isLoading } = state.repository.source.file;
  const srcDirMetadataState = state.repository.source.srcDirMetadata;

  let lastUpdated;

  if (hash && meta) {
    const pathSegments = meta.path.split('/');
    const parentDirectoryPath = pathSegments.slice(0, -1).join('/') || '/';
    const filePath = pathSegments.slice(-1)[0];

    const srcDirMetadata =
      srcDirMetadataState[`${hash}:${parentDirectoryPath}`];

    lastUpdated = srcDirMetadata?.data?.[filePath]?.lastModified?.date || null;
  }

  return {
    file,
    meta,
    isLoading,
    lastUpdated,
  };
};

export default connect(mapStateToProps)(FileDetailsCard);
